<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2toc"><a id="page_viii"></a><a id="page_ix"><span class="txbf">CONTENTS</span></a></h2><a id="page_ix">
</a><p class="toc"><a id="page_ix"></a><a href="#/xhtml/ch01"><span class="fonth">1</span>  Toy Soldiers</a></p>
<p class="toc1"><a href="#/xhtml/ch02"><span class="fonth">2</span>  Shut Up and Listen</a></p>
<p class="toc1"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="fonth">3</span>  Piss and Shit</span></p>
<p class="toc1"><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="fonth">4</span>  The Wild West</span></p>
<p class="toc1"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="fonth">5</span>  Honaker-Miracle</span></p>
<p class="toc1"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="fonth">6</span>  Finish Strong</span></p>
<p class="toc1"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="fonth">7</span>  The Last Sprint</span></p>
<p class="toc1"><span href="#/xhtml/ch08" title="Link target outside of Sample"><span class="fonth">8</span>  Freak on a Leash</span></p>
<p class="toc1"><span href="#/xhtml/ch09" title="Link target outside of Sample"><span class="fonth">9</span>  A Leg Up</span></p>
<p class="toc2"><span href="#/xhtml/ch10" title="Link target outside of Sample"><span class="fonth">10</span>  A Greater Honor</span></p>
<p class="toc3"><span href="#/xhtml/bm01" title="Link target outside of Sample"><span class="fonth">EPILOGUE</span>  The Next Mission</span></p>
<p class="toc4"><span href="#/xhtml/bm02" title="Link target outside of Sample"><span class="fonth">ACKNOWLEDGMENTS</span> Flo Groberg</span></p>
<p class="toc4"><span href="#/xhtml/bm03" title="Link target outside of Sample"><span class="fonth">ACKNOWLEDGMENTS</span> Tom Sileo</span></p>
<p class="toc4"><span href="#/xhtml/author" title="Link target outside of Sample"><span class="fonth">ABOUT THE AUTHOR</span></span></p>
<p class="toc4"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="fonth">INDEX</span></span><a id="page_x"></a><a id="page_xi"></a><a id="page_xii"></a></p><a id="page_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5747af21